module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/public/views/faqs.json
// module id = 609
// module chunks = 117